import axios, { AxiosInstance } from 'axios';
import { DateTime } from 'luxon';
import { ComboBoxDTO, PrestazioneConfigDTO, PuntoServizioDTO, UserDTO } from '../common/Dtos';

export interface StateAuth {
	isAuthenticated: boolean;
	token: string | null;
	axiosInstance: AxiosInstance | null;
	token_expiredate: DateTime | null;
	login: string | null;
	prettyName: string | null;
	roles: string[] | null;
	puntiServizio: ComboBoxDTO[];
	cooperativa: string | null;
	id: string | null;
	pswExpirationDate: string | null,
	checkEmail: boolean | null;
	checkVerificaEmail: boolean | null;
	puntoServizioLogged: PuntoServizioDTO | undefined | null;
	canale: string | null;
	prestazioniConfList: PrestazioneConfigDTO[] | null;
	backofficeInCorso: number | null;
}

export interface payloadLogin {
	login: string,
	prettyName: string,
	cooperativa: string,
	token: string,
	expiration: string,
	pswExpirationDate: string,
	roles: string[];
	email: string;
	puntiServizio: ComboBoxDTO[];
	id: string;
	puntoServizioLogged: PuntoServizioDTO | undefined;
	canale: string;
	checkEmail: boolean;
	checkVerificaEmail: boolean;
	prestazioniConfList: PrestazioneConfigDTO[];
	backofficeInCorso: number;
}

export interface payloadUpdatePrestazioniConfig {
	prestazioniConfList: PrestazioneConfigDTO[];
}

export interface payloadUpdateBackofficeInCorso {
	backofficeInCorso: number;
}

export interface payloadUpdateCurrentUser {
	user: UserDTO;
}

export interface payloadUpdatePswExpirationDate {
	pswExpirationDate: string;
}

export type ActionAuth =
	| { type: 'LOGIN', payload: payloadLogin }
	| { type: 'LOGOUT' }
	| { type: 'UPDATE_PREST', payload: payloadUpdatePrestazioniConfig }
	| { type: 'UPDATE_BACKOFFICE_IN_CORSO', payload: payloadUpdateBackofficeInCorso }
	| { type: 'UPDATE_CURRENT_USER', payload: payloadUpdateCurrentUser }
	| { type: 'ADIBA', payload: payloadLogin }
	| { type: 'UPDATE_PSW_EXP', payload: payloadUpdatePswExpirationDate }


export const reducer = (state: StateAuth, action: ActionAuth): StateAuth => {//reducer type di state (sono stati piu complessi piu custom)
	switch (action.type) {
		case "LOGIN":
			const qs = require('qs');
			localStorage.clear();
			localStorage.setItem("payloadLogin", JSON.stringify(action.payload));
			const instance: AxiosInstance = axios.create(/*{ baseURL: "/api" }*/) // se c'e' bisogno si puo cambiare la base url se e' diversa da quella generale
			instance.defaults.headers.common['Accept'] = 'application/json'   // default header for all request
			instance.defaults.headers.common['Content-Type'] = 'application/json';
			instance.defaults.headers.common['Authorization'] = "Bearer " + action.payload.token
			instance.defaults.headers.common['Uuid-Session'] = Buffer.from(new Date().getTime() + '|' + action.payload.id, 'binary').toString('base64');
			// Add a request interceptor
			instance.interceptors.request.use(function (config) {
				const uuid = new Date().getTime() + '|' + action.payload.id + '|' + config.url;
				console.log('uuid = ', uuid);
				config.headers['Uuid-Req'] = Buffer.from(uuid, 'binary').toString('base64');
				config.paramsSerializer = (params) => qs.stringify(params, {
					serializeDate: (date: Date) => date.toISOString()
				});
				return config;
			}, function (error) {
				console.error(error)
				return Promise.reject(error);
			});

			// Add a response interceptor
			instance.interceptors.response.use(function (response) {
				// Any status code that lie within the range of 2xx cause this function to trigger
				// Do something with response data

				return response;
			}, function (error) {
				// Any status codes that falls outside the range of 2xx cause this function to trigger
				// Do something with response error
				if (error.response && (401 === error.response.status || 403 === error.response.status)) {
					console.error("401 - token dead")
					localStorage.clear()
					window.location.href = "/login"
				}

				console.error(error)
				return Promise.reject(error);
			});
			let newstate: StateAuth = {
				axiosInstance: instance,
				//email: action.payload.email,
				isAuthenticated: true,
				prettyName: action.payload.prettyName,
				roles: action.payload.roles,
				token: action.payload.token,
				token_expiredate: DateTime.fromISO(action.payload.expiration),
				login: action.payload.login,
				pswExpirationDate: action.payload.pswExpirationDate,
				puntiServizio: action.payload.puntiServizio,
				cooperativa: action.payload.cooperativa,
				id: action.payload.id,
				checkEmail: action.payload.checkEmail,
				checkVerificaEmail: action.payload.checkVerificaEmail,
				puntoServizioLogged: action.payload.puntoServizioLogged,
				canale: action.payload.canale,
				prestazioniConfList: action.payload.prestazioniConfList,
				backofficeInCorso: action.payload.backofficeInCorso
			}
			return newstate
		case "LOGOUT":
			localStorage.clear();
			let loggedout_state: StateAuth = {
				//email: null,
				prettyName: null,
				roles: null,
				isAuthenticated: false,
				token: null,
				token_expiredate: null,
				axiosInstance: null,
				login: null,
				puntiServizio: [],
				cooperativa: null,
				pswExpirationDate: null,
				id: null,
				checkEmail: null,
				puntoServizioLogged: null,
				canale: null,
				prestazioniConfList: null,
				checkVerificaEmail: null,
				backofficeInCorso: null
			}
			return loggedout_state
		case "UPDATE_PREST":
			const localLoginPayloadStr = localStorage.getItem('payloadLogin');
			if (localLoginPayloadStr) {
				const payloadLogin = JSON.parse(localLoginPayloadStr);
				const newPayload = {
					...payloadLogin,
					prestazioniConfList: action.payload.prestazioniConfList
				}
				localStorage.setItem("payloadLogin", JSON.stringify(newPayload));
			}

			let updatedstate: StateAuth = {
				...state,
				prestazioniConfList: action.payload.prestazioniConfList
			}
			return updatedstate
		case "UPDATE_BACKOFFICE_IN_CORSO":
			const localLoginPayloadString = localStorage.getItem('payloadLogin');
			if (localLoginPayloadString) {
				const payloadLogin = JSON.parse(localLoginPayloadString);
				const newPayload = {
					...payloadLogin,
					backofficeInCorso: action.payload.backofficeInCorso
				}
				localStorage.setItem("payloadLogin", JSON.stringify(newPayload));
			}

			let updatedstatebackoffice: StateAuth = {
				...state,
				backofficeInCorso: action.payload.backofficeInCorso
			}
			return updatedstatebackoffice
		case "UPDATE_CURRENT_USER":
			const localLoginPayloadUser = localStorage.getItem('payloadLogin');
			if (localLoginPayloadUser) {
				const payloadLogin = JSON.parse(localLoginPayloadUser);
				const newPayload = {
					...payloadLogin,
					login: action.payload.user.login,
					roles: action.payload.user.authorities,
					prettyName: action.payload.user.lastname + " " + action.payload.user.firstname
				}
				localStorage.setItem("payloadLogin", JSON.stringify(newPayload));
			}

			let updatedstateuser: StateAuth = {
				...state,
				login: action.payload.user.login,
				roles: action.payload.user.authorities,
				prettyName: action.payload.user.lastname + " " + action.payload.user.firstname
			}
			return updatedstateuser
		case "ADIBA":
			const payloadLogin = localStorage.getItem('payloadLogin');
			if (payloadLogin) {
				const payloadLoginObj = JSON.parse(payloadLogin); const instance: AxiosInstance = axios.create(/*{ baseURL: "/api" }*/) // se c'e' bisogno si puo cambiare la base url se e' diversa da quella generale
				instance.defaults.headers.common['Accept'] = 'application/json'   // default header for all request
				instance.defaults.headers.common['Content-Type'] = 'application/json';
				instance.defaults.headers.common['Authorization'] = "Bearer " + action.payload.token
				instance.defaults.headers.common['Uuid-Session'] = Buffer.from(new Date().getTime() + '|' + action.payload.id, 'binary').toString('base64');
				// Add a request interceptor
				instance.interceptors.request.use(function (config) {
					const uuid = new Date().getTime() + '|' + action.payload.id + '|' + config.url;
					console.log('uuid = ', uuid);
					config.headers['Uuid-Req'] = Buffer.from(uuid, 'binary').toString('base64');
					config.paramsSerializer = (params) => qs.stringify(params, {
						serializeDate: (date: Date) => date.toISOString()
					});
					return config;
				}, function (error) {
					console.error(error)
					return Promise.reject(error);
				});

				// Add a response interceptor
				instance.interceptors.response.use(function (response) {
					// Any status code that lie within the range of 2xx cause this function to trigger
					// Do something with response data

					return response;
				}, function (error) {
					// Any status codes that falls outside the range of 2xx cause this function to trigger
					// Do something with response error
					if (error.response && (401 === error.response.status || 403 === error.response.status)) {
						console.error("401 - token dead")
						localStorage.clear()
						window.location.href = "/login"
					}

					console.error(error)
					return Promise.reject(error);
				});

				return {
					...payloadLoginObj,
					axiosInstance: instance,
					isAuthenticated: true
				};
			}
			return state
		case "UPDATE_PSW_EXP":
			const sessionUser = localStorage.getItem('payloadLogin');
			if (sessionUser) {
				const payloadLogin = JSON.parse(sessionUser);
				const newPayload = {
					...payloadLogin,
					pswExpirationDate: action.payload.pswExpirationDate
				}
				localStorage.setItem("payloadLogin", JSON.stringify(newPayload));
			}

			let updatedPswExp: StateAuth = {
				...state,
				pswExpirationDate: action.payload.pswExpirationDate
			}
			return updatedPswExp
		default:
			return state

	}
}
export const initialStateReducer: StateAuth = {
	//email: null,
	prettyName: null,
	roles: null,
	isAuthenticated: false,
	token: null,
	token_expiredate: null,
	axiosInstance: null,
	login: null,
	puntiServizio: [],
	cooperativa: null,
	id: null,
	pswExpirationDate: null,
	puntoServizioLogged: null,
	canale: null,
	prestazioniConfList: null,
	backofficeInCorso: null,
	checkVerificaEmail: null,
	checkEmail: null
};
